export default "__VITE_ASSET__BxWgGo79__"